// Game boot — the scene roster + Game.create + run(), and nothing else. This is
// a SKELETON: it boots a title → play → game-over flow that draws placeholder
// text. Grow the game by adding files:
//   scenes/    — one `Scene` subclass per screen (Title, Play, GameOver…)
//   entities/  — one `Sprite` subclass per file (player, enemy, bullet, pickup…)
//   assets/    — procgen art (sprite/tile factory functions)
//   config.ts  — the boot options and ALL tuning numbers
import { Game } from '../engine/webgpu.js';
import { GAME_OPTIONS } from './config.js';
import { Title } from './scenes/title.js';
import { Play } from './scenes/play.js';
import { GameOver } from './scenes/gameover.js';

// Game.create is async (it acquires the GPU device — WebGPU, or the built-in
// WebGL2 fallback where WebGPU is absent), so the boot is a top-level await.
// `play` is required; `title` and `gameOver` have built-in fallbacks if omitted.
// Boot order: the first registered of intro → title → play. Move between screens
// with this.gotoTitle() / gotoPlay() / gotoGameOver(result) from inside a scene.
// run() starts the frame loop; with a scene roster it takes no callback.
const game = await Game.create({
  ...GAME_OPTIONS,
  scenes: { title: Title, play: Play, gameOver: GameOver },
});
game.run();
